import { TAG_COLORS, TAG_COLOR_CLASSES } from 'constants/tagColors'
import { tagManagementStrings } from 'constants/strings'
import type { TTagColor } from 'types'
import { cn } from 'utils/cn'

type TagColorPickerProps = {
  value: TTagColor
  onChange: (color: TTagColor) => void
  disabled?: boolean
}

// 8色のスウォッチをラジオ的に選択する。選択中はリングで強調する。
export function TagColorPicker({
  value,
  onChange,
  disabled = false,
}: TagColorPickerProps) {
  return (
    <div
      role="radiogroup"
      aria-label={tagManagementStrings.form.colorLabel}
      className="flex flex-wrap gap-2"
    >
      {TAG_COLORS.map((color) => {
        const classes = TAG_COLOR_CLASSES[color]
        const selected = value === color

        return (
          <button
            key={color}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={tagManagementStrings.colorNames[color]}
            disabled={disabled}
            onClick={() => onChange(color)}
            className={cn(
              'h-9 w-9 rounded-full ring-inset transition disabled:cursor-not-allowed disabled:opacity-50',
              classes.bg,
              selected
                ? 'ring-2 ring-accent ring-offset-2'
                : cn('ring-1', classes.ring),
            )}
          />
        )
      })}
    </div>
  )
}
